import React from 'react'
import Box from '../components/Box'

export default function Section6() {
    return (
        <div className="section">
            <h2>Section VI: Attendance</h2>
            <Box sectionData={'start'} title={'Record Attendance '} body={`tNote: Student photos can be zoomed to full resolution by tapping the photo. 
            1. Select the class as described above. 
            2. Tap the “Manage” button and select “Attendance” from the menu. 
            3. Tap the “+” button to add a new attendance record. 
            4. Tap  the  “Date”  button  and  select  the  proper  date  for  the  attendance  record.    Todays  date  is 
            selected by default. 
            5. All students default to blank status. Select the “Present” (green checkmark) “Absent” (red x) or 
            “Tardy” (yellow clock) for each student as appropriate.  You may also use the “Mark All” button 
            to mark all students as “Present”, “Absent (Unexcused)”, or Tardy (Unexcused)”. 
            a. Swipe the field and tap “Delete” to clear the entry. 
            6. If a student is marked “Absent” or “Tardy” the “Excused/Unexcused” toggle button and a notes 
            field will appear. 
            a. All  “Absent”  and  “Tardy”  events  default  to  “Unexcused”  status  (thumbs-down  symbol).  
            Tap the symbol to toggle to “Excused” status (thumbs-up symbol).  Tap the button again 
            to toggle back to “Unexcused”. 
            b. Tap the notes field to enter a note. 
            7. If a student is marked “Present” a notes field will appear.  Tap the field to enter a note. 
            8. Tap “Done”.est`} />


            <Box title={'Add Attendance Notes '} body={`Note:  
            • Notes can be entered on a per-student basis or for the attendance record. This procedure will 
            add a note to the attendance record and will not be associated with an individual student. 
            1. Select the class as described above.  
            2. Tap the “Manage” button and select “Attendance” from the menu. 
            3. Select the appropriate attendance record entry from the list.  
            4. Tap “Notes”.  
            5. The note field will slide into view.  
            6. Enter or edit assignment notes.  
            7. Tap “Notes” again to hide the note field.`} />


            <Box title={'Email Students'} body={`1. Select the class as described above. 
            2. Tap the “Manage” button and select “Attendance” from the menu. 
            3. Select the appropriate attendance record entry from the list. 
            4. Tap “Email”. 
            5. Select the appropriate subset of students (absent, tardy, all). 
            6. A blank email is generated and addressed to all relevant students.`} />


            <Box title={'Email an Attendance Record'} body={`1. Select the class as described above. 
            2. Tap the “Manage” button and select “Attendance” from the menu. 
            3. Tap “Email”. 
            4. Tap “Daily Report”. 
            5. Address and send the message`} />


            <Box title={'Edit an Attendance Record'} body={`1. Select the class as described above. 
            2. Tap the “Manage” button and select “Attendance” from the menu. 
            3. Select the appropriate attendance record entry from the list. 
            4. Make the desired changes and tap “Done”`} />


            <Box title={'Delete an Attendance Record'} body={`Note:  
            • This cannot be undone. 
            1. Select the class as described above. 
            2. Tap the “Manage” button and select “Attendance” from the menu. 
            3. Tap the “Edit” button. 
            4. Tap the “-“ button for the record to be deleted. 
            5. Tap “Delete” to confirm. 
            6. Tap ‘Delete Record’ to confirm again.`} />

            <Box sectionData={'end'} title={'Quick Add Attendance Record '} body={`1. Select a class as described above. 
            2. Tap the “Action” button on the bottom toolbar. 
            3. Select “Record Attendance” 
            4. Follow steps (4) – (6) in the “Record Attendance” section above.`} />
        </div>
    )
}